import AccountMenu from './AccountMenu'
import Wordmark from './Wordmark'

export default function TopBar() {
  return (
    <header className="h-14 shrink-0 border-b border-ob-secondary/20 bg-ob-surface">
      <div className="flex h-full items-center justify-between px-4 md:px-16">
        <Wordmark size="sm" />
        <AccountMenu />
      </div>
    </header>
  )
}
